import { z } from 'zod';
import { AUTHTOKEN as localStorageKey } from '../KEYS';

// account is the SSO-known wallet address, null for walletless accounts.
// The kind literal is a parse-time discriminator: any row without it (legacy
// wallet-login rows) reads as "no session" — deliberately, those hold token
// pairs this app must not resume.
type AuthValue = {
  kind: 'sso';
  account: string | null;
  accessToken: string;
  refreshToken: string;
};

const AuthSchema: z.ZodType<AuthValue> = z.object({
  kind: z.literal('sso'),
  account: z.string().min(1).nullable(),
  accessToken: z.string().min(1),
  refreshToken: z.string().min(1),
});

export default {
  get(): AuthValue | null {
    const raw = localStorage.getItem(localStorageKey);
    // Stryker disable next-line ConditionalExpression: equivalent — a null row would go through JSON.parse as "null" and be rejected by the schema into the same null; this line is the fast path and the TS narrowing.
    if (raw === null) return null;
    try {
      return AuthSchema.parse(JSON.parse(raw));
    } catch {
      return null;
    }
  },

  set(value: AuthValue | null) {
    if (value === null) localStorage.removeItem(localStorageKey);
    else localStorage.setItem(localStorageKey, JSON.stringify(value));
  },
};
